import ProjectCard from "../PageLayout/ProjectCard";
import InfoPopup from "../Utils/InfoPopup.jsx";
import { ProjectType } from "../Utils/ProjectType.ts";
import ProjectHeader from "./ProjectHeader";
import sharedStyles from "./shared.module.css";
import ProjectButton from "../Utils/ProjectButton.jsx";



export default function Menace () {


    return (
        <ProjectCard projectName={'MENACE'}>

            <ProjectHeader title={"MENACE"} subTitle={"Manchester Metropolitan University Project"} projectType={ProjectType.Code} subTitleInfo="I studied for an MSc in Data Science at Manchester Metropolitan University, achieving a distinction." />

            <p>
                <InfoPopup info="MENACE stands for 'Matchbox Educable Noughts and Crosses Engine'."><strong>MENACE</strong></InfoPopup> is a <strong>Reinforcement Learning</strong> algorithm developed by Donald Michie in the 1960s using matchboxes and beads. 
            </p>

            <p>
                I implemented MENACE as a <strong>C#</strong> class library and then built an educational website to present it using <strong>ASP.NET MVC</strong>, <strong>Entity Framework</strong> and, <strong>SQL Server</strong>.
            </p>



            <div class="videoWrapper">
                <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/EuHD7uCyb1I" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>

            <br />

            <div className={sharedStyles.links}>
                <ProjectButton link={"https://github.com/Portman123/Menace-Web-App?"} name={"Code"} />

                <ProjectButton link={"/documents/MENACE-Website-Dissertation.pdf"} name={"Dissertation"} />

            </div>

        </ProjectCard>
    )
}